import api from '@/api/appGatewayServerApi'
import {StreamerUser} from '@/models/StreamerUser'

export const getUserStreamer = async (
): Promise<StreamerUser | undefined> => {
  const fetchedUser = await fetchUserForToken()
  if (!fetchedUser) return
  return fetchedUser
}

const fetchUserForToken = async (): Promise<StreamerUser | undefined> => {
  try {
    const response = await api.streamer.owner.get({
      isLatestCounting: false,
    })
    return response.streamer
  } catch (e) {
    return
  }
}
